import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=5e7b8416&"
var script = {}
import style0 from "./TermsAndConditions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports